var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"MIDAS-TOAST-loading--apple"},[_c('BaseLoading',{attrs:{"is-loading":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }